import apiFetch from '../apiFetch'

export default function (commentIds, token) {
  return apiFetch({ endPoint: 'Comment/MarkAsRead', method: 'PUT', body: commentIds, token: token })
}
